import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TelefonoService {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }

  getTelefonosByCliente(filter:any){
    return this.http.get(`${this.baserApiUrl}telefonos?${filter}`,)
  }

  addTelefono(data:any){
    return this.http.post(`${this.baserApiUrl}telefonos`,data)
  }
}
